import { useMemo } from 'react'
import { Icon as IconComp, type TIconProps } from '~/components/icon'
import { type ScopedProps, useCardCategoryContext } from '../../card-category'

export const Icon = (props: TIconProps) => {
  const { __scopeCardCategory } = props as ScopedProps<TIconProps>
  const { orientation, disabled, isHovered, isPressed, context } =
    useCardCategoryContext('CardCategoryLabel', __scopeCardCategory)

  const color = useMemo(() => {
    if (disabled && context === 'neutral') {
      return 'colorTextNeutralDisabled'
    }
    if (disabled) {
      return 'colorTextNeutralDisabled'
    }
    if (context === 'brand' && isPressed) {
      return 'colorActionTextOnbrandPressed'
    }
    if (context === 'brand' && isHovered) {
      return 'colorActionTextOnbrandHovered'
    }
    if (context === 'neutral') {
      return 'colorTextNeutralAlternative'
    }
    if (context === 'brand') {
      return 'colorTextNeutralAlternative'
    }
    if (isPressed) {
      return 'colorActionTextOnbrandPressed'
    }
    if (isHovered) {
      return 'colorActionTextOnbrandHovered'
    }
    return undefined
  }, [isHovered, isPressed, disabled, context])

  return (
    <IconComp
      {...props}
      size={orientation === 'horizontal' ? 'small' : 'medium'}
      color={color}
    />
  )
}
